import React from 'react';
import PropTypes from 'prop-types';
import { ContentFooter } from '@bingads-webui-campaign-react/content-footer';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const reportShellStyle = () => ({
  contentFooter: {
    display: 'flex',
    flexDirection: 'column-reverse',
    width: '100%',
    position: 'static',
    marginTop: 'auto',
  },
});

function UnStyledReportsV4Footer(props) {
  return (
    <div className={props.classes.contentFooter}>
      <ContentFooter />
    </div>
  );
}

UnStyledReportsV4Footer.propTypes = {
  classes: PropTypes.shape({
    contentFooter: PropTypes.string,
  }).isRequired,
};

export const ReportsV4Footer = withDefaultStyles(UnStyledReportsV4Footer, reportShellStyle);
